import { useEffect } from "react";

const SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function useFocusTrap(ref, active, onClose) {
  useEffect(() => {
    if (!active || !ref.current) return;
    const prev = document.activeElement;
    const node = ref.current;
    const first = node.querySelector(SELECTOR);
    if (first) first.focus();
    const handler = (e) => {
      if (e.key === "Escape") {
        onClose && onClose();
        return;
      }
      if (e.key !== "Tab") return;
      const els = Array.from(node.querySelectorAll(SELECTOR));
      if (!els.length) return;
      const firstEl = els[0];
      const lastEl = els[els.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      } else if (!e.shiftKey && document.activeElement === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    };
    document.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.style.overflow = "";
      if (prev && prev.focus) prev.focus();
    };
  }, [active, ref, onClose]);
}
